import { ELSCommonUIConstants } from '@els/els-ui-common-react';
import { RoutePath } from 'constants/app.constant';
export var UserHomeRoutes = {
    getUserHome: function () {
        var _a;
        return (_a = {},
            _a[ELSCommonUIConstants.userType.Instructor] = RoutePath.home,
            _a[ELSCommonUIConstants.userType.Student] = RoutePath.student.home,
            _a);
    }
};
